/**
 * @generated SignedSource<<ee769bb07fc8de98f42dda68608fab42>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuestionAnswerListItem_Question$data = {
  readonly defaultMaxDuration: number | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"AnswerListItem_Question">;
  readonly " $fragmentType": "QuestionAnswerListItem_Question";
};
export type QuestionAnswerListItem_Question$key = {
  readonly " $data"?: QuestionAnswerListItem_Question$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuestionAnswerListItem_Question">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuestionAnswerListItem_Question",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultMaxDuration",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerListItem_Question"
    }
  ],
  "type": "Question",
  "abstractKey": null
};

(node as any).hash = "4b4a64115b5570b76a266649214ebdf4";

export default node;
